import { type FC } from 'react';
import { BsFillXCircleFill } from 'react-icons/bs';
import { useDispatch } from 'react-redux';

import { removeProgramFromList } from '@core/reducers/matchesSlice';
import type { VoyagerResult } from '@core/ts/results';

import styles from './CompactCard.module.css';

type Props = {
  hit: VoyagerResult;
  showClose?: boolean;
};

const CompactCard: FC<Props> = ({ hit, showClose = true }) => {
  const dispatch = useDispatch();
  const clickHandler = () => {
    dispatch(removeProgramFromList(hit));
  };

  if (!hit) return null;

  return (
    <div className={styles.card}>
      <div className={styles.logo}>
        <img
          src={`https://simple-storage-server.highereducation.com/${hit?.school?.slug}.png?w=130&h=80`}
          alt={hit?.school?.name}
        />
      </div>
      <span className={styles.subtitle}>{hit?.program?.name}</span>
      {showClose && (
        <button type="button" className={styles.removeBtn} onClick={clickHandler}>
          <BsFillXCircleFill />
        </button>
      )}
    </div>
  );
};

export { CompactCard };
